import { render, staticRenderFns } from "./LostQuoteNotes.vue?vue&type=template&id=46951e36"
import script from "./LostQuoteNotes.vue?vue&type=script&lang=js"
export * from "./LostQuoteNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports